// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__7RLcb","loader":"Loading_loader__119R0","dot":"Loading_dot__3T4_J","text":"Loading_text__1wTpw","loading-text":"Loading_loading-text__2VUBC"};